import { Amplify } from 'aws-amplify';
import { getApiConfig } from '../config/api';

export function configureAmplify() {
  const config = getApiConfig();
  if (!config.userPoolId || !config.userPoolClientId) {
    console.warn('Missing Cognito configuration');
    return;
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.userPoolId,
        userPoolClientId: config.userPoolClientId,
        loginWith: { email: true },
      },
    },
  });
}
